export default "__VITE_ASSET__BEMuP$2j__"